import { render, staticRenderFns } from "./ShowConfig.vue?vue&type=template&id=61270fc4&scoped=true"
import script from "./ShowConfig.vue?vue&type=script&lang=js"
export * from "./ShowConfig.vue?vue&type=script&lang=js"
import style0 from "./ShowConfig.vue?vue&type=style&index=0&id=61270fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61270fc4",
  null
  
)

export default component.exports